function contentSideCollage() {
	const self = this;

	self.rootElements = [];
	self.scrollDirection = 'down';
	self.previousScrollTop = 0;
	self.allImageObjects = null;

	function isInView(element) {
		const bounding = element.getBoundingClientRect();
		return (
			bounding.top < (window.innerHeight / 2) &&
			bounding.bottom > (window.innerHeight / 2) &&
			bounding.left < window.innerWidth &&
			bounding.right > 0
		);
	}

	function setScrollDirection() {
		const currentScrollTop = window.scrollY || document.documentElement.scrollTop;

		if (currentScrollTop > self.previousScrollTop) {
			self.scrollDirection = 'down';
		} else {
			self.scrollDirection = 'up';
		}

		self.previousScrollTop = currentScrollTop;
	}

	function getTranslateY(element) {
		return element.style.transform ? Number(element.style.transform.split("(")[1].split("p")[0]) : 0;
	}

	function responsiveSize(screenWidth) {
    const minWidth = 768;
    const maxWidth = 1440;
    const minSize = 96;
    const maxSize = 144;

    // Ensure the screenWidth is within the specified range
    if (screenWidth <= minWidth) {
      return minSize;
    } else if (screenWidth >= maxWidth) {
      return maxSize;
    }

    // Calculate the font size using linear interpolation
    const slope = (maxSize - minSize) / (maxWidth - minWidth);
    const size = minSize + slope * (screenWidth - minWidth);

    return Math.floor(size);
	}

	function handleScroll() {
		self.rootElements.forEach((rootElement, id) => {
			if (isInView(rootElement)) {
				const maxTranslate = ((matchMedia("(min-width: 768px)").matches) ? responsiveSize(window.innerWidth) : 48) * 0.8;
				const image1 = self.allImageObjects[id][0] ? self.allImageObjects[id][0] : null;
				const image2 = self.allImageObjects[id][1] ? self.allImageObjects[id][1] : null;

				const divider = image1.image.offsetHeight / 2.5;
				const multiplier = 0.75;

				const curTranslate = getTranslateY(image1.image);
				const addTranslate = Math.floor(image1.image.offsetHeight / divider);

				let image1Translate = curTranslate + addTranslate * (self.scrollDirection === 'down' ? -1 : 1);

				if (image1Translate > maxTranslate) {
					image1Translate = maxTranslate;
				} else if (image1Translate < -maxTranslate) {
					image1Translate = -maxTranslate;
				}

				image1.image.style.transform = `translateY(${image1Translate}px)`;
				self.allImageObjects[id][0].transform = image1Translate;

				if (image2) {
					let image2Translate = image1Translate * multiplier;

					if (image2Translate > maxTranslate) {
						image2Translate = maxTranslate;
					} else if (image2Translate < -maxTranslate) {
						image2Translate = -maxTranslate;
					}

					image2.image.style.transform = `translateY(${image2Translate}px)`;
					self.allImageObjects[id][1].transform = image2Translate;
				}
			}
		});
	}

	self.getRootElements = () => {
		const rootElements = [...document.querySelectorAll(".block-content-side-collage")];
		if (self.rootElements.length < 1 && rootElements.length > 0) self.rootElements = rootElements;
	}

	self.getAllImages = () => {
		if (self.allImageObjects === null) self.allImageObjects = [];

		self.rootElements.forEach((rootElement) => {
			const images = [...rootElement.querySelectorAll(".image-wrapper")];
			const REImages = [];

			if (images.length > 0) {

				images.forEach((image) => {
					REImages.push({image, transform: image.style.transform ? Number(image.style.transform.split("(")[1].split("p")[0]) : 0});
				});
			}

			self.allImageObjects.push(REImages);
		});
	}

	self.setEvents = () => {
		window.addEventListener("scroll", () => {
			setScrollDirection();
			handleScroll();
		});
	}

	self.init = () => {
		self.getRootElements();
		if (self.rootElements.length < 1) return;

		self.getAllImages();
		self.setEvents();
	}

	return this;
}

function contentSideCollageA11Y() {
	const block = document.querySelector('.block-content-side-collage');
	const overlineText = block.querySelectorAll('.has-overline-font-size');

	overlineText.forEach((heading) => {
		heading.setAttribute('role', 'heading');
		heading.setAttribute('aria-level', '4');
	});
}

const contentSideCollageObject = new contentSideCollage();

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		contentSideCollageA11Y();
	},
	loaded() {
		contentSideCollageObject.init();
	},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
